package com.kinoshazam.update.data

import com.kinoshazam.data.GlobalStateRepository

actual class DownloadManager actual constructor(globalStateRepository: GlobalStateRepository) {
    actual suspend fun downloadUpdate() {
    }
}